import React from "react"
import { Form, Input, Radio, notification } from "antd"
import Modal from "../../components/modal/DraggableModal"   // talabnoma §8.2 (2026-09-06): siljitiladigan modal
import { useTranslation } from "react-i18next"
import { useForm } from "antd/lib/form/Form"

export enum ExcelExtensions {
  XLSX = "xlsx",
  CSV = "csv",
  PDF = "pdf",
}

export enum ExportOptions {
  hasDetail = "hasDetail",
  noDetail = "noDetail",
}

export interface IExcelOptions {
  filename: string
  worksheetName: string
  extension: ExcelExtensions
  hasDetail?: number
}

export interface IExportOptions {
  onOk: (obj: IExcelOptions) => void
  onCancel: () => void
  visible: boolean
  loading?: boolean
}

export default function ExportOptionsModal({
  onOk,
  visible,
  onCancel,
  loading,
}: IExportOptions) {
  const { t } = useTranslation()
  const [form] = useForm()

  function handleFinish() {
    form
      .validateFields()
      .then((values: IExcelOptions) => onOk(values))
      .catch((err) => {
        notification.error({
          message: t("validationError"),
          description: err.toString(),
        })
      })
  }

  return (
    <Modal
      visible={visible}
      okText={loading ? t("loading") + " ..." : t("export")}
      onOk={handleFinish}
      onCancel={onCancel}
      cancelText={t("cancel")}
      confirmLoading={loading}
    >
      <Form
        form={form}
        name="export-excel"
        initialValues={{
          extension: ExcelExtensions.XLSX,
          hasDetail: 1,
        }}
      >
        <Form.Item
          label={t("exportType")}
          name="hasDetail"
          rules={[{ required: true, message: t("requiredField") }]}
        >
          <Radio.Group>
            <Radio.Button value={1}>{t(ExportOptions.noDetail)}</Radio.Button>
            {/* <Radio.Button value={0}>{t(ExportOptions.noDetail)}</Radio.Button> */}
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label={t("fileType")}
          name="extension"
          rules={[{ required: true, message: t("requiredField") }]}
        >
          <Radio.Group>
            <Radio.Button value={ExcelExtensions.XLSX}>
              {ExcelExtensions.XLSX}
            </Radio.Button>
            <Radio.Button value={ExcelExtensions.CSV}>
              {ExcelExtensions.CSV}
            </Radio.Button>
            <Radio.Button value={ExcelExtensions.PDF}>
              {ExcelExtensions.PDF}
            </Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="filename"
          label={t("filename")}
          rules={[{ required: true, message: t("requiredField") }]}
        >
          <Input placeholder={t("title")} />
        </Form.Item>
        <Form.Item
          name="worksheetName"
          label={t("worksheetName")}
          rules={[{ required: true, message: t("requiredField") }]}
        >
          <Input placeholder={t("title")} />
        </Form.Item>
      </Form>
    </Modal>
  )
}
